export default {
    props: {
      data: {
        Type: Object
      }
    },
    created() {
      this.form = this.data;
      this.onInput(this.form);
    },
    methods: {
      onInput(val) {
        this.$bus.$emit("input", val);
      },
      amtFormat(val) {
        return this.$numeral(val).format('0,0')
      }
    },
    // watch: {
    //   data: {
    //     immediate: true,
    //     deep: true,
    //     handler(value) {
    //       this.form = value;
    //     }
    //   }
    // }
  };
  